// extracted by mini-css-extract-plugin
export default {"container":"Home_container__8kVa-","loader":"Home_loader__gNjyl","movies":"Home_movies__5+YFj"};